// oxlint-disable-next-line no-restricted-imports -- Legacy table migration/demo — do not copy into new code.
import {
    GridTable,
    GridTableHeader,
    GridTableRow,
} from "@design-system/Tables/GridTable/GridTable";

interface Props {
    data: Array<Record<string, number | string>>;
}

export const FinancialDocumentCsvPreview: React.FC<Props> = ({ data }) => {
    if (data.length === 0) {
        return null;
    }

    const headers = Object.keys(data[0]);

    if (headers.length === 0) {
        return null;
    }

    return (
        <GridTable
            gridTemplateColumns={`repeat(${headers.length}, max-content)`}
            noBorder
        >
            <GridTableHeader
                columns={headers.map((header) => ({
                    key: header,
                    label: header,
                }))}
            />

            {data.map((row, idx) => (
                <GridTableRow key={idx}>
                    {headers.map((header) => (
                        <div key={header}>{row[header]}</div>
                    ))}
                </GridTableRow>
            ))}
        </GridTable>
    );
};
